import Lightbox from "bs5-lightbox";
import * as bootstrap from "bootstrap";
import "owl.carousel";

$(function () {
  // Product varieties on product page

  $(".df-product__info__varieties__item__color").on("click", function() {
    const slug = $(this).data("product-slug");
    if (!$(this).hasClass("active") && slug) {
      window.location = slug;
    }
  });

  $(".df-product__info__varieties__item input").on("change", function() {
    window.location = $(this).val();
  });

  // Показ большого изображения в модалке галереи

  const imageFullscreenModal = new bootstrap.Modal(document.querySelector('#js-image-fullscreen'));

  $(document).on('click', '.lightbox.modal.show .btn-zoom', function() {
    const img = document.querySelector('.lightbox.modal.show .active img');
    const imgSrc = img.attributes.src.value;
    const bigImg = document.createElement('img');
    bigImg.src = imgSrc;
    const modalEl = document.querySelector('#js-image-fullscreen');
    modalEl.querySelector('.image-fullscreen__container').appendChild(bigImg);
    imageFullscreenModal.show();
  });

  $(document).on('click', '#js-image-fullscreen .close', function () {
    document.querySelector('#js-image-fullscreen .image-fullscreen__container img').remove();
  });

  const initLightbox = (el) => (event) =>  {
    event.preventDefault();
    const lightbox = new Lightbox(el, {
      keyboard: true,
    });

    lightbox.modalElement.addEventListener("shown.bs.modal", (e) => {
      const modal = e.target;
      const zoomBtn = document.createElement("button");
      zoomBtn.className = lightbox.el.getAttribute('data-slide-type') === 'image' ? "btn-zoom" : "btn-zoom d-none";
      modal.querySelector(".modal-body").appendChild(zoomBtn);
    });

    lightbox.carouselElement.addEventListener("slid.bs.carousel", (e) => {
      const carousel = e.target;
      const modal = lightbox.modalElement;
      if (carousel.querySelector('.active').querySelector('img')) {
        modal.querySelector('.btn-zoom').classList.remove('d-none');
      } else {
        modal.querySelector('.btn-zoom').classList.add('d-none');
      }
    });

    lightbox.show();
  };

  document.querySelectorAll(".df-product__gallery__item[data-gallery=df-gallery]").forEach((el) =>
    el.addEventListener("click", initLightbox(el))
  );

  document.querySelectorAll(".df-product__gallery__item[data-gallery=df-gallery--mobile]").forEach((el) =>
    el.addEventListener("click", initLightbox(el))
  );

  // Mobile gallery carousel

  $("#js-product-gallery-carousel").owlCarousel({
    autoplay: false,
    loop: true,
    nav: true,
    navText: ["", ""],
    navContainerClass: "df-owl__nav",
    navClass: ["df-owl__nav__prev", "df-owl__nav__next"],
    navElement: "div",
    navSpeed: 0.35,
    dots: true,
    dotsClass: "df-owl__dots",
    dotClass: "df-owl__dots__item",
    items: 1,
  });

  // Desktop gallery collapse

  document
    .querySelectorAll(".js-gallery-hidden-thumbnail-item")
    .forEach((el) => {
      el.addEventListener("show.bs.collapse", () => {
        if (!$(".js-gallery-more-photos").hasClass("d-none")) {
          $(".js-gallery-more-photos").addClass("d-none");
        }
      });

      el.addEventListener("hide.bs.collapse", () => {
        if ($(".js-gallery-more-photos").hasClass("d-none")) {
          $(".js-gallery-more-photos").removeClass("d-none");
        }
      });
    });
});
